import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Check, UploadCloud, MapPin, Home, FileText, ShieldCheck, CreditCard, ArrowRight, ArrowLeft, FileSignature } from 'lucide-react';
export const ListProperty = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const totalSteps = 5;
  const steps = [{
    id: 1,
    title: 'Property Info',
    icon: Home
  }, {
    id: 2,
    title: 'Location',
    icon: MapPin
  }, {
    id: 3,
    title: 'Documents',
    icon: FileText
  }, {
    id: 4,
    title: 'Verification',
    icon: ShieldCheck
  }, {
    id: 5,
    title: 'Payment',
    icon: CreditCard
  }];
  const handleNext = () => {
    if (step < totalSteps) setStep(step + 1);else navigate('/dashboard/seller'); // Mock completion
  };
  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };
  return <div className="min-h-screen bg-neutral-light flex flex-col" data-id="element-1972">
      {/* Header */}
      <header className="bg-white border-b border-neutral-200 py-4 px-6 sticky top-0 z-20" data-id="element-1973">
        <div className="container mx-auto flex items-center justify-between" data-id="element-1974">
          <Link to="/" className="flex items-center gap-2" data-id="element-1975">
            <div className="w-8 h-8 rounded bg-primary-900 flex items-center justify-center font-serif font-bold text-xl text-secondary" data-id="element-1976">
              A
            </div>
            <span className="font-serif font-bold text-xl tracking-tight text-primary-900 hidden sm:block" data-id="element-1977">
              AMU
            </span>
          </Link>
          <div className="text-sm font-bold text-text-light" data-id="element-1978">
            List Property • Step {step} of {totalSteps}
          </div>
          <Link to="/" className="text-sm font-bold text-error hover:text-error/80" data-id="element-1979">
            Cancel
          </Link>
        </div>
      </header>

      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl" data-id="element-1980">
        {/* Stepper */}
        <div className="mb-10" data-id="element-1981">
          <div className="flex items-center justify-between relative" data-id="element-1982">
            <div className="absolute left-0 right-0 top-1/2 h-0.5 bg-neutral-200 -translate-y-1/2 z-0" data-id="element-1983"></div>
            <div className="absolute left-0 top-1/2 h-0.5 bg-secondary -translate-y-1/2 z-0 transition-all duration-500" style={{
            width: `${(step - 1) / (totalSteps - 1) * 100}%`
          }} data-id="element-1984"></div>

            {steps.map(s => {
            const Icon = s.icon;
            const isActive = s.id === step;
            const isCompleted = s.id < step;
            return <div key={s.id} className="relative z-10 flex flex-col items-center gap-2" data-id="element-1985">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-300 ${isCompleted ? 'bg-secondary text-white' : isActive ? 'bg-primary-900 text-white shadow-lg ring-4 ring-primary-100' : 'bg-white border-2 border-neutral-200 text-neutral-400'}`} data-id="element-1986">
                    {isCompleted ? <Check size={20} data-id="element-1987" /> : <Icon size={18} data-id="element-1988" />}
                  </div>
                  <span className={`text-xs font-bold hidden md:block ${isActive ? 'text-primary-900' : 'text-text-light'}`} data-id="element-1989">
                    {s.title}
                  </span>
                </div>;
          })}
          </div>
        </div>

        {/* Form Content */}
        <div className="bg-white rounded-2xl shadow-soft border border-neutral-200 p-6 md:p-10 min-h-[400px]" data-id="element-1990">
          {step === 1 && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4" data-id="element-1991">
              <h2 className="text-2xl font-serif font-bold text-primary-900 mb-6" data-id="element-1992">
                Property Details
              </h2>

              <div data-id="element-1993">
                <label className="block text-sm font-bold text-text mb-2" data-id="element-1994">
                  Property Title
                </label>
                <input type="text" placeholder="e.g. Luxury 5-Bedroom Detached Duplex" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1995" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1996">
                <div data-id="element-1997">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-1998">
                    Property Type
                  </label>
                  <select className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-1999">
                    <option data-id="element-2000">House</option>
                    <option data-id="element-2001">Land</option>
                    <option data-id="element-2002">Apartment</option>
                    <option data-id="element-2003">Commercial</option>
                  </select>
                </div>
                <div data-id="element-2004">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-2005">
                    Asking Price (₦)
                  </label>
                  <input type="number" placeholder="0.00" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-2006" />
                </div>
              </div>

              <div className="grid grid-cols-3 gap-6" data-id="element-2007">
                <div data-id="element-2008">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-2009">
                    Bedrooms
                  </label>
                  <input type="number" placeholder="0" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-2010" />
                </div>
                <div data-id="element-2011">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-2012">
                    Bathrooms
                  </label>
                  <input type="number" placeholder="0" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-2013" />
                </div>
                <div data-id="element-2014">
                  <label className="block text-sm font-bold text-text mb-2" data-id="element-2015">
                    Size (sqm)
                  </label>
                  <input type="number" placeholder="0" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-2016" />
                </div>
              </div>

              <div data-id="element-2017">
                <label className="block text-sm font-bold text-text mb-2" data-id="element-2018">
                  Description
                </label>
                <textarea rows={4} placeholder="Describe the property..." className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-2019"></textarea>
              </div>
            </div>}

          {step === 2 && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4" data-id="element-2020">
              <h2 className="text-2xl font-serif font-bold text-primary-900 mb-6" data-id="element-2021">
                Location & Tier
              </h2>

              <div data-id="element-2022">
                <label className="block text-sm font-bold text-text mb-2" data-id="element-2023">
                  District
                </label>
                <select className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-2024">
                  <optgroup label="Tier 1 — Premium" data-id="element-2025">
                    <option data-id="element-2026">Asokoro</option>
                    <option data-id="element-2027">Maitama</option>
                    <option data-id="element-2028">Maitama Hill</option>
                    <option data-id="element-2029">Aso Drive</option>
                    <option data-id="element-2030">Guzape</option>
                    <option data-id="element-2031">Katampe 1</option>
                    <option data-id="element-2032">Katampe 2</option>
                  </optgroup>
                  <optgroup label="Tier 2 — Upper-Mid Value" data-id="element-2033">
                    <option data-id="element-2034">Apo</option>
                    <option data-id="element-2035">Gudu</option>
                    <option data-id="element-2036">Wuse Zone 1</option>
                    <option data-id="element-2037">Wuse Zone 2</option>
                    <option data-id="element-2038">Jabi</option>
                    <option data-id="element-2039">LifeCamp</option>
                    <option data-id="element-2040">Gwarimpa</option>
                    <option data-id="element-2041">Wuye</option>
                  </optgroup>
                  <optgroup label="Tier 3 — Growing & Residential" data-id="element-2042">
                    <option data-id="element-2043">Kuje</option>
                    <option data-id="element-2044">Karsana</option>
                    <option data-id="element-2045">Idu</option>
                    <option data-id="element-2046">Kubwa</option>
                    <option data-id="element-2047">Lugbe</option>
                    <option data-id="element-2048">Kado</option>
                    <option data-id="element-2049">Karu</option>
                    <option data-id="element-2050">Durumi</option>
                  </optgroup>
                </select>
              </div>

              <div className="p-4 bg-primary-50 border border-primary-100 rounded-xl flex items-start gap-3" data-id="element-2051">
                <MapPin className="text-primary-900 shrink-0 mt-0.5" size={20} data-id="element-2052" />
                <div data-id="element-2053">
                  <h4 className="font-bold text-primary-900" data-id="element-2054">
                    Tier 1 Location Detected
                  </h4>
                  <p className="text-sm text-text-light mt-1" data-id="element-2055">
                    Maitama is classified as a Tier 1 location. This affects
                    listing pricing and verification requirements.
                  </p>
                </div>
              </div>

              <div data-id="element-2056">
                <label className="block text-sm font-bold text-text mb-2" data-id="element-2057">
                  Full Address
                </label>
                <input type="text" placeholder="Street address" className="w-full px-4 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none" data-id="element-2058" />
              </div>
            </div>}

          {step === 3 && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4" data-id="element-2059">
              <div className="flex items-start justify-between mb-6" data-id="element-2060">
                <div data-id="element-2061">
                  <h2 className="text-2xl font-serif font-bold text-primary-900 mb-2" data-id="element-2062">
                    Document Upload
                  </h2>
                  <p className="text-text-light" data-id="element-2063">
                    Upload clear copies of title documents for AGIS/FCDA
                    verification.
                  </p>
                </div>
                <div className="px-3 py-1 bg-neutral-100 text-neutral-dark text-xs font-bold rounded-full flex items-center gap-1" data-id="element-2064">
                  <ShieldCheck size={14} data-id="element-2065" /> Secure
                </div>
              </div>

              <div className="space-y-4" data-id="element-2066">
                {[{
              label: 'Certificate of Occupancy (C of O)',
              required: true,
              icon: UploadCloud
            }, {
              label: 'Government Issued ID',
              required: true,
              icon: UploadCloud
            }, {
              label: 'Utility Bill / Proof of Address',
              required: true,
              icon: UploadCloud
            }, {
              label: 'Deed of Assignment',
              required: false,
              icon: UploadCloud
            }, {
              label: 'Power of Attorney (POA) — only if you are an authorized seller',
              required: false,
              icon: FileSignature
            }].map((doc, i) => {
              const Icon = doc.icon;
              return <div key={i} className="border-2 border-dashed border-neutral-200 rounded-xl p-6 flex flex-col items-center justify-center text-center hover:bg-neutral-50 hover:border-secondary transition-colors cursor-pointer" data-id="element-2067">
                      <Icon size={32} className="text-neutral-400 mb-3" data-id="element-2068" />
                      <h4 className="font-bold text-text mb-1 flex items-center gap-2" data-id="element-2069">
                        Upload {doc.label}
                        {!doc.required && <span className="text-[10px] font-bold px-2 py-0.5 rounded bg-neutral-100 text-neutral-500 uppercase" data-id="element-2070">
                            Optional
                          </span>}
                      </h4>
                      <p className="text-xs text-text-light" data-id="element-2071">
                        PDF, JPG or PNG (Max 10MB)
                      </p>
                    </div>;
            })}
              </div>
            </div>}

          {step === 4 && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 text-center py-8" data-id="element-2072">
              <div className="w-20 h-20 bg-primary-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2073">
                <ShieldCheck size={40} className="text-primary-900" data-id="element-2074" />
              </div>
              <h2 className="text-2xl font-serif font-bold text-primary-900 mb-4" data-id="element-2075">
                Verification Review
              </h2>
              <p className="text-text-light max-w-md mx-auto mb-8" data-id="element-2076">
                Your documents will be securely transmitted to our compliance
                team for AGIS/FCDA verification. This process typically takes
                24-48 hours.
              </p>

              <div className="bg-neutral-50 p-6 rounded-xl text-left max-w-md mx-auto border border-neutral-200" data-id="element-2077">
                <h4 className="font-bold text-text mb-4" data-id="element-2078">Summary</h4>
                <div className="space-y-2 text-sm" data-id="element-2079">
                  <div className="flex justify-between" data-id="element-2080">
                    <span className="text-text-light" data-id="element-2081">Property:</span>{' '}
                    <span className="font-medium" data-id="element-2082">Luxury 5-Bed Duplex</span>
                  </div>
                  <div className="flex justify-between" data-id="element-2083">
                    <span className="text-text-light" data-id="element-2084">Location:</span>{' '}
                    <span className="font-medium" data-id="element-2085">Maitama (Tier 1)</span>
                  </div>
                  <div className="flex justify-between" data-id="element-2086">
                    <span className="text-text-light" data-id="element-2087">Documents:</span>{' '}
                    <span className="font-medium text-success" data-id="element-2088">3 Uploaded</span>
                  </div>
                </div>
              </div>
            </div>}

          {step === 5 && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4" data-id="element-2089">
              <h2 className="text-2xl font-serif font-bold text-primary-900 mb-2" data-id="element-2090">
                Listing Payment
              </h2>
              <p className="text-text-light mb-6" data-id="element-2091">
                Pay the listing fee to submit your property for verification.
              </p>

              <div className="bg-primary-900 text-white p-6 rounded-2xl mb-6 relative overflow-hidden" data-id="element-2092">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-2093"></div>
                <h3 className="text-lg font-serif font-bold mb-1" data-id="element-2094">
                  Tier 1 Listing Fee
                </h3>
                <p className="text-primary-200 text-sm mb-4" data-id="element-2095">
                  Maitama District
                </p>
                <div className="text-3xl font-bold" data-id="element-2096">₦300,000</div>
              </div>

              <div className="space-y-3" data-id="element-2097">
                <label className="flex items-center justify-between p-4 border border-secondary bg-secondary/5 rounded-xl cursor-pointer" data-id="element-2098">
                  <div className="flex items-center gap-3" data-id="element-2099">
                    <input type="radio" name="payment" defaultChecked className="text-secondary focus:ring-secondary" data-id="element-2100" />
                    <span className="font-bold text-text" data-id="element-2101">Paystack</span>
                  </div>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Paystack_Logo.png" alt="Paystack" className="h-5 object-contain grayscale opacity-70" data-id="element-2102" />
                </label>
                <label className="flex items-center justify-between p-4 border border-neutral-200 rounded-xl cursor-pointer hover:bg-neutral-50" data-id="element-2103">
                  <div className="flex items-center gap-3" data-id="element-2104">
                    <input type="radio" name="payment" className="text-secondary focus:ring-secondary" data-id="element-2105" />
                    <span className="font-bold text-text" data-id="element-2106">Bank Transfer</span>
                  </div>
                </label>
              </div>
            </div>}
        </div>

        {/* Footer Actions */}
        <div className="mt-8 flex items-center justify-between" data-id="element-2107">
          <button onClick={handleBack} className={`flex items-center gap-2 px-6 py-3 rounded-xl font-bold transition-colors ${step === 1 ? 'opacity-0 pointer-events-none' : 'text-text hover:bg-white'}`} data-id="element-2108">
            <ArrowLeft size={18} data-id="element-2109" /> Back
          </button>

          <button onClick={handleNext} className="flex items-center gap-2 bg-primary-900 hover:bg-primary-800 text-white px-8 py-3 rounded-xl font-bold transition-colors shadow-lg" data-id="element-2110">
            {step === totalSteps ? 'Pay & Submit' : 'Continue'}{' '}
            <ArrowRight size={18} data-id="element-2111" />
          </button>
        </div>
      </main>
    </div>;
};